import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Waypoint } from 'react-waypoint';
import Button from '../../../Button';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import s from './ThreadPagination.scss';
var ThreadPagination = function (_a) {
    var hasMore = _a.hasMore, isInfinite = _a.isInfinite, isFetching = _a.isFetching, onLoadMore = _a.onLoadMore, className = _a.className, biData = _a.biData, direction = _a.direction;
    var t = useTranslation().t;
    var logBiEvent = useBiLogger();
    var onInfiniteScroll = useCallback(function () {
        if (!biData) {
            return;
        }
        logBiEvent(biData);
        onLoadMore();
    }, [biData, logBiEvent, onLoadMore]);
    if (!hasMore) {
        return null;
    }
    if (isInfinite) {
        return React.createElement(Waypoint, { topOffset: 100, onEnter: onInfiniteScroll });
    }
    if (direction !== 'next') {
        return (React.createElement("div", { className: s['button-wrap'] },
            React.createElement(GhostButton, { size: 'small', variant: 'main', onClick: onLoadMore, biData: biData, disabled: isFetching }, t('commentthread.control.loadprev'))));
    }
    return (React.createElement(Button, { view: "b3", onClick: onLoadMore, biData: biData, disabled: isFetching, className: classnames(s['button'], className) }, direction === 'next'
        ? t('commentthread.control.loadmore')
        : t('commentthread.control.loadprev')));
};
ThreadPagination.displayName = 'ThreadPagination';
export default ThreadPagination;
//# sourceMappingURL=ThreadPagination.js.map